import { render, staticRenderFns } from "./ShopXsollaPaymentView.vue?vue&type=template&id=dd6702ce&"
import script from "./ShopXsollaPaymentView.vue?vue&type=script&lang=js&"
export * from "./ShopXsollaPaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports